import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=b5cc1570&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"
import style0 from "./Demo.vue?vue&type=style&index=0&id=b5cc1570&prod&lang=scss&scoped=true"
import style1 from "./Demo.vue?vue&type=style&index=1&id=b5cc1570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cc1570",
  null
  
)

export default component.exports